import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';



// import '@/utils/rem.js'
import Carousel3d from 'vue-carousel-3d'
Vue.use(Carousel3d)
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import '@/utils/flexible'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import "@/assets/css/index.css"

// // 优雅引入axios
// import axios from 'axios';
// import VueAxios from 'vue-axios';
// axios.defaults.baseURL="https://www.fnrddbyj.com/platform/";
// Vue.use(VueAxios,axios);

import Echarts from 'echarts'
Vue.prototype.echarts = Echarts
Vue.use(Echarts)

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
